import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {LoadCurrentClient} from './current-client.actions';
import {Observable, tap} from 'rxjs';
import {CurrentClientService} from '@tisa-group/core';
import {UmpireCurrentClient} from '@tisa-group/models';
import {JsonApiResponse} from '@tisa-group/cdk';

export type CurrentClientStateModel = JsonApiResponse<UmpireCurrentClient> | null;

@State<CurrentClientStateModel>({
  name: 'CurrentClient',
  defaults: null,
})
@Injectable()
export class CurrentClientState {
  @Action(LoadCurrentClient)
  loadCurrentClient(
    ctx: StateContext<CurrentClientStateModel>,
    action: LoadCurrentClient,
  ):
    | Observable<JsonApiResponse<UmpireCurrentClient>>
    | JsonApiResponse<UmpireCurrentClient> {
    const stateCurrentClient = ctx.getState();

    if (stateCurrentClient) {
      return stateCurrentClient;
    }

    return this.currentClientService.fetch().pipe(tap(res => ctx.setState(res)));
  }

  @Selector()
  static isCMPEnabled(state: CurrentClientStateModel): boolean {
    return !!state?.data?.config?.external_dependencies?.cmp?.src;
  }

  @Selector()
  static getData(state: CurrentClientStateModel): UmpireCurrentClient | undefined {
    return state?.data;
  }

  constructor(readonly currentClientService: CurrentClientService) {}
}
